import './assets/main.css'

import { defineCustomElement } from 'vue'
import { createPinia, setActivePinia } from 'pinia'
import App from './App.ce.vue'

setActivePinia(createPinia());

const ExportFormElement = defineCustomElement(App)
customElements.define('export-form', ExportFormElement)
